import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
} from '@angular/core';
import { getAbbreviation } from '@interacta-shared/util';
import { getAgentColorClass } from '@modules/ai-convo/helpers/ai-convo-panel.utils';
import { AIConvoAgent } from '@modules/ai-convo/models/ai-convo-agent.model';

@Component({
    selector: 'interacta-ai-convo-agent-list-item',
    templateUrl: './ai-convo-agent-list-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AIConvoAgentListItemComponent {
    readonly agent = input.required<AIConvoAgent>();
    readonly showDescription = input(false);
    readonly agentClick = output<AIConvoAgent>();

    readonly abbreviation = computed(() =>
        getAbbreviation(this.agent().name).toUpperCase(),
    );

    readonly colorClass = computed(() =>
        getAgentColorClass(this.agent().color),
    );
}
